<template>
    <div class="wrapper">
        <h1 class="crumb">完工列表</h1>
        <div class="bar">
            <div class="btnGroup">
                <span style="margin-left: 50px;">安装日期　</span>
                <el-date-picker
                    v-model="installDate"
                    type="daterange"
                    range-separator="至"
                    @change="get_staff_position_list"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <el-select v-model="ssgn" placeholder="请选择" style="width: 150px;margin-left: 30px">
                    <el-option
                        v-for="item in ssgnSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <span><el-input v-model="searchKey" style="width: 200px" placeholder="请输入"></el-input></span>
                <el-button class="btn" @click="get_staff_position_list" style="">搜索</el-button>
            </div>
        </div>
        <div class="table">
            <el-table style="width: 100%" :data="tableData" size="small">
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" style="font-size: 12px" @click="Detail(scope.row)">详情</el-button><span> | </span>
                        <el-button type="text" style="font-size: 12px" @click="beizhu(scope.row)">完工备注</el-button><span> | </span>
                        <el-button type="text" style="font-size: 12px" @click="dayin(scope.row)">A4打印</el-button><span> | </span>
                        <el-button type="text" style="font-size: 12px" @click="dayin2(scope.row)">A5打印</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="销售单位" prop="referer" align="center" :formatter="XSDW"></el-table-column>
                <el-table-column label="提货单号" width="100" align="center">
                    <template slot-scope="props">
                        <div  style="font-size: 10px;" :style="props.row.referer ==='管理员添加'?{color:'red'}:''">{{props.row.referer !=='管理员添加'?props.row.install_sn:'只安装'}}</div>
                    </template>
                </el-table-column>
                <!--<el-table-column label="合同订单号" prop="contract_number" align="center"></el-table-column>-->
                <el-table-column label="型号" width="120" align="center">
                    <template slot-scope="props">
                        <div v-for="item in props.row.order_goods" style="font-size: 10px">{{item.goods_attr_select.length ===0?item.goods_attr:item.goods_attr_select[0]}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="数量" width="50" align="center">
                    <template slot-scope="props">
                        <div v-for="item in props.row.order_goods">{{item.goods_number}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="提单号" prop="tidan" align="center" width="80"></el-table-column>
                <el-table-column label="安装码" prop="install_code" align="center" width="80"></el-table-column>
                <el-table-column align="center" label="客户" prop="consignee"></el-table-column>
                <el-table-column align="center" label="电话" prop="mobile"></el-table-column>
                <el-table-column label="备用电话" prop="tel" align="center"></el-table-column>
                <el-table-column align="center" label="地址" prop="address_all" width="200"></el-table-column>
                <el-table-column align="center" label="安装工程队" prop="team_name"></el-table-column>
                <el-table-column align="center" label="预约安装日期" prop="yuyue_time" sortable></el-table-column>
                <el-table-column align="center" label="备注" prop="remark" width="120"></el-table-column>
                <el-table-column align="center" label="费用" width="120">
                    <template slot-scope="props">
                        <div @click="Details(props.row,+props.row.fee_gaokong+ +props.row.fee_nandu+ +props.row.fee_yuancheng+ +props.row.fee_chaizhuang+ +props.row.fee_gangguan+ +props.row.fee_zhijia)" style="cursor: pointer;color: orangered;">￥{{+props.row.fee_gaokong+ +props.row.fee_nandu+ +props.row.fee_yuancheng+ +props.row.fee_chaizhuang+ +props.row.fee_gangguan+ +props.row.fee_zhijia}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="完工备注" prop="team_done_remark" width="120"></el-table-column>

            </el-table>
        </div>
        <!-- 修改员工信息 -->
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout=" total,prev, pager, next"
            :total="total">
        </el-pagination>
        <el-dialog title="安装单详情" :visible.sync="InstallDetail" width="400px">
            <el-form :model="form" style="text-align: left;margin-top: 20px;" class="c-table">
                <el-form-item label="安装信息:" :label-width="formLabelWidth">
                    <div v-if="form.status_name === '未安装'">{{form.status_name}}</div>
                    <div v-else>{{form.status_name }} ({{form.yuyue_time}})</div>
                </el-form-item>
                <!--<el-form-item label="安装变更记录:" :label-width="formLabelWidth">-->
                <!--<div v-if="form.finish_time === ''">暂无安装变更记录</div>-->
                <!--<div v-else>{{form.comment}}</div>-->
                <!--</el-form-item>-->
                <el-form-item label="评分:" :label-width="formLabelWidth">
                    <div><span>安装及时:</span><el-rate disabled v-model="form.service_send" style="display: inline-block"></el-rate></div>
                    <div><span>安装态度:</span><el-rate disabled v-model="form.service_state" style="display: inline-block"></el-rate></div>
                    <div><span>安装规范:</span><el-rate disabled v-model="form.service_clear" style="display: inline-block"></el-rate></div>
                </el-form-item>
                <el-form-item label="客户评论:" :label-width="formLabelWidth">
                    <div v-if="form.comment === ''">暂无评论</div>
                    <div v-else>{{form.comment}}</div>
                </el-form-item>
                <el-form-item :label="item.name?item.name+':':''" :label-width="formLabelWidth" v-for="item in form.fee_other" :key="item.name" v-show="typeof form.fee_other==='object'">
                    <div>{{item.price}}</div>
                </el-form-item>
                <el-form-item label="支架费:" :label-width="formLabelWidth" v-show="form.fee_zhijia!=='0.00'">
                    <div>{{form.fee_zhijia}}</div>
                </el-form-item>
                <el-form-item label="高空费:" :label-width="formLabelWidth" v-show="form.fee_gaokong!=='0.00'">
                    <div>{{form.fee_gaokong}}</div>
                </el-form-item>
                <el-form-item label="铜管费:" :label-width="formLabelWidth" v-show="form.fee_gaokong!=='0.00'">
                    <div>{{form.fee_gangguan}}</div>
                </el-form-item>
                <el-form-item label="难度费:" :label-width="formLabelWidth" v-show="form.fee_nandu!=='0.00'">
                    <div>{{form.fee_nandu}}</div>
                </el-form-item>
                <el-form-item label="远程费:" :label-width="formLabelWidth" v-show="form.fee_yuancheng!=='0.00'">
                    <div>{{form.fee_yuancheng}}</div>
                </el-form-item>
                <el-form-item label="拆装机费:" :label-width="formLabelWidth" v-show="form.fee_chaizhuang!=='0.00'">
                    <div>{{form.fee_chaizhuang}}</div>
                </el-form-item>
                <el-form-item label="其他费用:" :label-width="formLabelWidth" v-show="form.fee_other!=='0'&&typeof form.fee_other!=='object'">
                    <div>{{form.fee_other}}</div>
                </el-form-item>
                <el-form-item label="附件查询:" :label-width="formLabelWidth">
                    <div v-if="(form.image1 === '/data/paylogimg/'&&form.image2 === '/data/paylogimg/'&&form.image3 === '/data/paylogimg/')&&form.images==''" >暂无附件</div>
                    <div v-else-if="form.image1 !== '/data/paylogimg/'||form.image2 !== '/data/paylogimg/'||form.image3 !== '/data/paylogimg/'">
                        <a target="_blank" :href="$reqUrl + form.image1"  v-if="form.image1 !=='/data/paylogimg/'"><img :src="$reqUrl + form.image1" alt="" style="width: 50px;height: 50px"></a>
                        <a target="_blank" :href="$reqUrl + form.image2" v-if="form.image2 !=='/data/paylogimg/'"><img :src="$reqUrl + form.image2" alt=""  alt=""  style="width: 50px;height: 50px"></a>
                        <a target="_blank" :href="$reqUrl + form.image3" v-if="form.image3 !=='/data/paylogimg/'"><img :src="$reqUrl + form.image3" alt=""  style="width: 50px;height: 50px"></a>
                    </div>
                    <div v-else>
                        <a v-for="item in form.images" target="_blank" :href="$reqUrl + item"><img :src="$reqUrl + item" alt="" style="width: 50px;height: 50px"></a>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button @click="InstallDetail = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="费用详情" :visible.sync="FeiyongDetail" width="400px">
            <div v-show="form.fee_other=='0'||typeof form.fee_other!=='object'">{{tests}}</div>
            <el-form :model="form" style="text-align: left;margin-top: 20px;" class="c-table">
                <el-form-item :label="item.name?item.name+':':''" :label-width="formLabelWidth" v-for="item in form.fee_other" :key="item.name" v-show="typeof form.fee_other==='object'">
                    <div>{{item.price}}</div>
                </el-form-item>
                <el-form-item label="支架费:" :label-width="formLabelWidth" v-show="form.fee_zhijia!=='0.00'">
                    <div>{{form.fee_zhijia}}</div>
                </el-form-item>
                <el-form-item label="高空费:" :label-width="formLabelWidth" v-show="form.fee_gaokong!=='0.00'">
                    <div>{{form.fee_gaokong}}</div>
                </el-form-item>
                <el-form-item label="铜管费:" :label-width="formLabelWidth" v-show="form.fee_gangguan!=='0.00'">
                    <div>{{form.fee_gangguan}}</div>
                </el-form-item>
                <el-form-item label="难度费:" :label-width="formLabelWidth" v-show="form.fee_nandu!=='0.00'">
                    <div>{{form.fee_nandu}}</div>
                </el-form-item>
                <el-form-item label="远程费:" :label-width="formLabelWidth" v-show="form.fee_yuancheng!=='0.00'">
                    <div>{{form.fee_yuancheng}}</div>
                </el-form-item>
                <el-form-item label="拆装机费:" :label-width="formLabelWidth" v-show="form.fee_chaizhuang!=='0.00'">
                    <div>{{form.fee_chaizhuang}}</div>
                </el-form-item>
                <el-form-item label="其他费用:" :label-width="formLabelWidth" v-show="form.fee_other!='0'&&typeof form.fee_other!=='object'">
                    <div>{{form.fee_other}}</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button @click="FeiyongDetail = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="完工备注" :visible.sync="Beizhu" width="500px">
            <el-form :model="forms" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="完工备注:" :label-width="formLabelWidth">
                    <el-input v-model="team_done_remark" style="width: 60%;float: left"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button  @click="Beizhu = false">取消</el-button>
                <el-button type="primary" @click="qrBeizhu">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getAddressSelect, getFinishList, postAppointment, session_id } from '../../stores/api';
    import { mapState } from 'vuex';
    import Vue from 'vue';
    import AddCompany from './AddCompany';
    import ElSelect from "element-ui";

    Vue.component('Add-Company', AddCompany);
    export default {
        // components: {ElSelect},
        data () {
            return {
                formData: {},
                dialogFormVisible:false,
                FeiyongDetail: false,
                InstallDetail: false,
                formList:[],
                form:'',
                page:1,
                total:0,
                currentPage1:1,
                ssgnSelect: [{name: '收货人电话', referer: 'mobile'}, {name: '提货单号', referer: 'contract_number'}, {name: '规格型号', referer: 'goods_attr'}],
                ssgn: 'mobile',
                searchKey: '', //关键字搜索
                installDate: '', //安装日期搜索
                options: [],
                position_id: '',
                tableData: [],
                cityList: [],
                districtList: [],
                formLabelWidth: '120px',

                ChangeInstallDate: false, //改期
                reasonList: [{value: '客户没时间', label: '客户没时间'}, {value: '装修未完成',label: '装修未完成'}, {value: '其它', label: '其它'}],
                change: {
                    changeDate: '',
                    changerReson: '',
                },
                Beizhu: false,
                team_done_remark: '',
                tests: '',
            };
        },
        computed: {
            ...mapState(['provinceList']),
        },
        methods: {
            beizhu(row) {
                this.Beizhu = true
                this.team_done_remark = row.team_done_remark
                this.bzId = row.install_id
            },
            qrBeizhu() {
                this.$http.post(this.$reqUrl + `service.php?act=install_done_remark&session_id=${localStorage.getItem('azgs_session_id')}&install_id=${this.bzId}&team_done_remark=${this.team_done_remark}`).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('添加备注成功')
                        this.get_staff_position_list()
                        this.Beizhu = false
                    } else {
                        this.$message.error('添加失败')
                    }
                })
            },
            XSDW(row) {  //格式化销售单位
                let name = ''
                if (row.referer === 'k3导入') {
                    name = row.store_name
                } else if (row.referer === '门店') {
                    name = row.store_name
                } else if (row.referer === '') {
                    name = ''
                } else {
                    name = row.store_name
                }
                return name
            },
            get_staff_position_list(page){
                let temp = {}
                temp.page = this.page
                if (this.installDate) {
                    console.log(this.installDate)
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10)
                }
                if (this.searchKey !== '') {
                    if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    }
                }
                getFinishList(temp).then(res => {
                        this.tableData = res.data.install_list;
                        if (this.tableData) {
                            res.data.install_list.forEach((item, i) => {
                                this.tableData[i]['diqu'] = item.province+item.city+item.district+item.address
                            })
                        }
                        this.total = res.data.count
                    })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.get_staff_position_list();
            },
            //详情
            Detail (row) {
                this.form = row
                this.InstallDetail = true
            },
            Details (row, price) {
                this.form = row
                this.tests = ''
                if (price === 0) {
                    this.tests = '无安装费用'
                }
                // console.log(row);
                this.FeiyongDetail = true
            },
            dayin(row) { //打印
                localStorage.setItem('installData', JSON.stringify(row))
                let routeData = this.$router.resolve({
                    name: "Printing",
                });
                window.open(routeData.href, '_blank');
                // this.$router.push({path: '/Printing'})
            },
            dayin2(row) { //打印
                localStorage.setItem('installData', JSON.stringify(row))
                let routeData = this.$router.resolve({
                    name: "Printing1",
                });
                window.open(routeData.href, '_blank');
                // this.$router.push({path: '/Printing1'})
            },
            //改期
            Change () {
                this.ChangeInstallDate = true
            },
            rqChangeDate () {
                console.log(this.change.changeDate);
                console.log();
            },
            //退货
            Return () {

            },
            //作废
            Delete () {

            }
        },
        mounted() {
            //获取员工信息列表

            this.get_staff_position_list();
            // this.getzw();
        }
    };
</script>

<style lang="less" >
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            button {
                width: 100Px;
                height: 37Px;
                margin-right: 10Px;
                font-size: 16px;
                color: #ffffff;
                background: #f56c31;
                border-radius: 2px;
            }
        }
    }
</style>
<style>
    .el-dialog{
        width: 500px;
        margin: 0 auto 50px;
    }
    .bosform{
        padding: 30Px 90Px 30Px 70Px;
    }
    .bosform .el-input{
        width: 260px;
        height: 32px;
    }
    .c-table .el-form-item{
        margin-bottom: 5px;
    }
    .el-dialog__body {
        padding-bottom: 30Px ;
        text-align: center;
    }
    .el-dialog__body input{
        border-radius: 0;
    }
    .el-table th>.cell{
        color:#ea6625;
    }
    .yx-popover-btn {
        margin-top: 10PX;
        width:120Px;
        height:35Px;
        font-size:16px;
        color:#ffffff;
        border-radius:4px;
    }
    .yx-popover-cancelBtn {
        margin-left: 10px;
        background:#d8dde6;
    }
</style>



// WEBPACK FOOTER //
// src/components/InstallationCompany/CompanyList.vue